import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '../api/adminClient';

export function useAdminMe() {
  return useQuery({
    queryKey: ['admin', 'me'],
    queryFn: () => adminApi.me(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

export function useAdminStats() {
  return useQuery({
    queryKey: ['admin', 'stats'],
    queryFn: () => adminApi.stats(),
    refetchInterval: 30000,
  });
}

export function useAdminScrapingSummary() {
  return useQuery({
    queryKey: ['admin', 'scraping', 'summary'],
    queryFn: () => adminApi.scraping.summary(),
    refetchInterval: 30000,
  });
}

export function useAdminScrapingErrors(params?: { limit?: number; offset?: number }) {
  return useQuery({
    queryKey: ['admin', 'scraping', 'errors', params],
    queryFn: () => adminApi.scraping.errors(params),
  });
}

export function useAdminScrapingFacilities(params?: { limit?: number; offset?: number; provider?: string; status?: string; sort?: string }) {
  return useQuery({
    queryKey: ['admin', 'scraping', 'facilities', params],
    queryFn: () => adminApi.scraping.facilities(params),
  });
}

export function useAdminTriggerScrape() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (facilityId: string) => adminApi.scraping.triggerScrape(facilityId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'scraping'] });
    },
  });
}

export function useAdminAvailabilityEvents() {
  return useQuery({
    queryKey: ['admin', 'availability', 'events'],
    queryFn: () => adminApi.availability.events(),
  });
}

export function useAdminHotFacilities() {
  return useQuery({
    queryKey: ['admin', 'availability', 'hot-facilities'],
    queryFn: () => adminApi.availability.hotFacilities(),
  });
}

export function useAdminUsers(params?: { limit?: number; offset?: number; search?: string }) {
  return useQuery({
    queryKey: ['admin', 'users', params],
    queryFn: () => adminApi.users(params),
  });
}

export function useAdminSystemHealth() {
  return useQuery({
    queryKey: ['admin', 'system', 'health'],
    queryFn: () => adminApi.system.health(),
  });
}

